import PropTypes from "prop-types";
import { FileText, CreditCard, LineChart } from "lucide-react";
import { cn } from "lib/utils";


const steps = [
  {
    icon: FileText,
    step: "01",
    title: "Do Your Research",
    description:
      "Review detailed company information, financials, team backgrounds, and risk factors.",
  },
  {
    icon: CreditCard,
    step: "02",
    title: "Make an Investment",
    description:
      "Invest online securely for as little as $100. Complete your investment in minutes.",
  },
  {
    icon: LineChart,
    step: "03",
    title: "Track Your Portfolio",
    description:
      "Monitor your investments and receive updates on company progress and milestones.",
  },
];

export function HowItWorksSection({ className }) {
  return (
    <section className={cn("bg-muted/30 py-16 sm:py-20", className)}>
      <div className="container mx-auto px-4 sm:px-6 lg:px-12 xl:px-16">
        <div className="mb-16 text-center">
          <h2 className="text-3xl font-bold tracking-tight">How Investing Works</h2>
          <p className="mx-auto mt-4 max-w-2xl text-muted-foreground">
            Start building your portfolio of private company investments in three simple steps.
          </p>
        </div>

        <div className="mx-auto grid max-w-5xl gap-8 md:grid-cols-3">
          {steps.map((step, index) => (
            <div key={step.step} className="relative">
              {index < steps.length - 1 ? (
                <div className="absolute top-12 left-1/2 hidden h-px w-full bg-border lg:block" />
              ) : null}

              <div className="relative text-center">
                <div className="relative inline-flex">
                  <div className="flex h-24 w-24 items-center justify-center rounded-full bg-secondary">
                    <step.icon className="h-10 w-10 text-foreground" />
                  </div>
                  <div className="absolute -top-2 -right-2 flex h-8 w-8 items-center justify-center rounded-full bg-accent text-sm font-bold text-accent-foreground">
                    {step.step}
                  </div>
                </div>
                <h3 className="mt-6 text-lg font-semibold">{step.title}</h3>
                <p className="mt-2 text-sm text-muted-foreground">{step.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

HowItWorksSection.propTypes = {
  className: PropTypes.string,
};
